import { useSelector } from 'react-redux';
import {
  getPlanNiceName,
  getPlanCommercialName,
  getPlanId,
  getPlanTransactionFee,
  getPlanName,
  getIsNext,
  getIsEvolucion,
  getIsFreePlan,
} from '../../authSlice/authSelectors';

interface useGetPlanResult {
  name: string;
  niceName: string;
  commercialName: string;
  transactionFee: number;
  planId: string;
  isNext: boolean;
  isEvolucion: boolean;
  isFreePlan: boolean;
}

function useGetPlan(): useGetPlanResult {
  const name = useSelector(getPlanName);
  const niceName = useSelector(getPlanNiceName);
  const commercialName = useSelector(getPlanCommercialName);
  const transactionFee = useSelector(getPlanTransactionFee);
  const isNext = useSelector(getIsNext);
  const isFreePlan = useSelector(getIsFreePlan);
  const isEvolucion = useSelector(getIsEvolucion);
  const planId = useSelector(getPlanId);

  return {
    name,
    niceName,
    commercialName,
    transactionFee,
    planId,
    isNext,
    isEvolucion,
    isFreePlan,
  };
}

export default useGetPlan;
